import { CallCopilotSectionHeader } from "./header";
import { useCallCopilot } from "@/modules/pipeline/account-details/hooks/use-call-copilot";
import { AccountDetailsSectionContainer } from "shared/ui/account-details/component-wrapper";
import { clsxMerge } from "shared/lib/helpers";
import { Fragment, useEffect } from "react";
import { useRef } from "react";

import { WEBSOCKET_CALL_COPILOT_EVENT_TYPES } from "@/lib/websockets/call-copilot/constants";
import { CallCopilotCompetitorMessage } from "./message-types/competitor";
import { CallCopilotObjectionMessage } from "./message-types/objection";

export const CallCopilotSection = () => {
  const { content } = useCallCopilot();

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = 0;
    }
  }, [content]);

  //TODO testing only
  // useEffect(() => {
  //   setContent?.([
  //     {
  //       type: "objection_copilot",
  //       data: {
  //         // objection: "Not interested / don't see the value.",
  //         objection:
  //           "Not interested because I don’t perceive any meaningful value or benefit in what’s being offered, and it doesn’t seem aligned with my priorities or goals at this time.",
  //         objection_handle:
  //           "• I understand—many clients felt the same until they saw they only pay for meetings that match their exact criteria.\n• What would a guaranteed, sales‑qualified meeting with your ideal buyer be worth to you?\n• Glencoco removes SDR salaries, ramp time, and tool costs; if we don't deliver meetings, you spend nothing.\n• Give me one target segment and I'll show you how our vetted reps can fill that gap risk‑free.",
  //       },
  //     },
  //     {
  //       data: {
  //         competitor: "Salesforce",
  //         competitor_description:
  //           "Salesforce is a leading CRM platform that offers cloud-based solutions for sales, service, marketing and analytics. They are known for their robust enterprise features and extensive app marketplace.",
  //         competitor_handle:
  //           "Key differentiators:\n- More expensive but offers comprehensive functionality\n- Strong focus on large enterprise customers\n- Extensive customization capabilities\n- Steeper learning curve for users",
  //       },
  //       type: "competitor_copilot",
  //     },
  //     {
  //       data: {
  //         competitor: "HubSpot",
  //         competitor_description:
  //           "HubSpot is an inbound marketing and sales platform that provides a full suite of marketing automation, CRM, and sales tools. They are particularly known for their content marketing and lead generation capabilities.",
  //         competitor_handle:
  //           "Key differentiators:\n- Strong focus on inbound marketing methodology\n- More affordable than enterprise solutions\n- User-friendly interface with gentle learning curve\n- Excellent marketing automation features\n- Free tier available for small businesses",
  //       },
  //       type: "competitor_copilot",
  //     },
  //   ]);
  // }, []);

  return (
    <AccountDetailsSectionContainer
      title={<CallCopilotSectionHeader content={content} />}
      headerClassName="bg-gradient-to-r from-[#F88167] to-[#FB56B4] text-white"
      className={clsxMerge({
        "overflow-hidden rounded-md": !content?.length,
      })}
      contentClassName={clsxMerge({
        "p-0": !content?.length,
        "p-2 py-0": content?.length,
      })}
    >
      <div
        className={clsxMerge("overflow-y-auto transition-all duration-300", {
          "max-h-[280px] pt-5": !!content?.length,
          "max-h-[0px]": !content?.length,
        })}
        ref={ref}
      >
        {content?.map((item, i) => (
          <Fragment key={content?.length - i}>
            {item.type ===
              WEBSOCKET_CALL_COPILOT_EVENT_TYPES.CALL_COPILOT_MESSAGE_COMPETITOR && (
              <CallCopilotCompetitorMessage {...(item.data || {})} />
            )}

            {item.type ===
              WEBSOCKET_CALL_COPILOT_EVENT_TYPES.CALL_COPILOT_MESSAGE_OBJECTION && (
              <CallCopilotObjectionMessage {...(item.data || {})} />
            )}
          </Fragment>
        ))}
      </div>
    </AccountDetailsSectionContainer>
  );
};
